import { useRouter } from "next/router";
import { useMemo } from "react";

const useHasCompleteParameter = (): boolean => {
  const router = useRouter();
  const hasComplete = useMemo(
    () => router.query.complete !== undefined,
    [router],
  );

  return hasComplete;
};
export default useHasCompleteParameter;
